import React, { useEffect, useReducer, useRef, useState } from 'react';
import {
  IconButton,
  Button,
  Tabs,
  Tab,
  RadioGroup,
  FormControlLabel,
  Radio,
} from '@material-ui/core';
import CancelIcon from '@material-ui/icons/Cancel';
import {
  addInRoomDiningDiscount,
  editInRoomDiningDiscount,
} from '../../../../../utils/ServicesAPIUtils';
import { notificationManager } from '../../../../../utils/NotificationUtils';
import CustomTextField from '../../../../../shared/form-controls/custom-text-field/Custom-Text-Field';
import { useDispatch, useSelector } from 'react-redux';
import { VALID_INTEGER, formDataValidate, handleValidation } from '../../../../../utils/formUtils';
import { fetchAllInRoomDining, inRoomDiningDiscountsSelector } from '../../../servicesSlice';
import LinearProgressBar from '../../../../../shared/progress-bar/Progress';
import {
  KeyboardTimePicker,
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from '@material-ui/pickers';
import MomentUtils from '@date-io/moment';
import WatchLaterIcon from '@mui/icons-material/WatchLater';
import KeyValuePairList from '../../../../../shared/key-value-pair-list/KeyValuePairList';
import moment from 'moment';
import CustomCheckbox from '../../../../../shared/form-controls/custom-checkbox/Custom-Checkbox';
import Tooltip from '@mui/material/Tooltip';
import { withStyles } from '@material-ui/core/styles';
import InfoIcon from '@mui/icons-material/Info';
import { decryptLocalStorage } from '../../../../../utils/authUtils';
import { stepDownLoaderCount, stepUpLoaderCount } from '../../../../../utils/loaderSlice';

const DiscountCreate = (props) => {
  const { toggleDrawer, discount, hotelId, restaurantId, showLoader = () => {} } = props;
  const dispatch = useDispatch();
  const [tabValue, setTabValue] = useState(0);
  const [loading, setLoading] = useState(false);
  const inRoomDiningDiscounts = useSelector(inRoomDiningDiscountsSelector);
  const [isTabInValid, setIsTabInValid] = useState(true);
  const [isValidDateInterval, setIsValidDateInterval] = useState(true);
  const [isValidTimeInterval, setIsValidTimeInterval] = useState(true);
  const formDataChange = useRef(null);
  const [formData, setFormData] = useReducer((state, newState) => ({ ...state, ...newState }), {
    name: {
      value: '',
      fieldName: 'Discount Name',
      errors: {},
      validations: ['required'],
      tab: 0,
    },
    code: {
      value: '',
      fieldName: 'Discount Code',
      errors: {},
      validations: ['required', 'validAlphaNumeric'],
      tab: 0,
    },
    value: {
      value: '',
      fieldName: 'Discount Value(%)',
      errors: {},
      validations: ['required', 'positiveOnly', VALID_INTEGER],
      tab: 0,
    },
    upto: {
      value: '',
      fieldName: 'Maximum Discount',
      errors: {},
      validations: ['required', 'positiveOnly', VALID_INTEGER],
      tab: 0,
    },
    disclaimer: {
      value: '',
      fieldName: 'Disclaimer',
      errors: {},
      validations: [],
      tab: 0,
    },
    description: {
      value: '',
      fieldName: 'Description',
      errors: {},
      validations: [],
      tab: 0,
    },
    customAttributes: {
      value: [],
      fieldName: 'Custom Attributes',
      errors: {},
      validations: [],
      tab: 0,
    },
    availableOn: {
      value: 'custom',
      fieldName: 'availableOn',
      errors: {},
      validations: ['required'],
      tab: 1,
    },
    fromDate: {
      value: moment().format('DD-MM-YYYY'),
      fieldName: 'Date',
      errors: {},
      validations: ['required', 'validDate'],
      tab: 1,
    },
    fromTime: {
      value: moment().format('HH:mm'),
      fieldName: 'Time',
      errors: {},
      validations: ['required', 'validTime'],
      tab: 1,
    },
    tillDate: {
      value: moment().add(1, 'days').format('DD-MM-YYYY'),
      fieldName: 'Date',
      errors: {},
      validations: ['required', 'validDate'],
      tab: 1,
    },
    tillTime: {
      value: moment().add(5, 'hours').format('HH:mm'),
      fieldName: 'time',
      errors: {},
      validations: ['required', 'validTime'],
      tab: 1,
    },
    status: {
      value: false,
      fieldName: 'Active',
      errors: {},
      validations: [],
      tab: 0,
    },
  });

  const CustomToolTip = withStyles({
    tooltip: {
      color: 'white',
      backgroundColor: 'black',
    },
  })(Tooltip);

  useEffect(() => {
    if (discount) {
      const currFields = { ...formData };
      for (let field in currFields) {
        currFields[field].value = discount[field];
      }
      currFields.availableOn.value = discount.schedule.always ? 'always' : 'custom';
      if (!discount.schedule.always) {
        currFields.fromDate.value = discount.schedule.from.date;
        currFields.tillDate.value = discount.schedule.till.date;
        currFields.fromTime.value = discount.schedule.from.time;
        currFields.tillTime.value = discount.schedule.till.time;
      } else {
        currFields.fromDate.value = moment().format('DD-MM-YYYY');
        currFields.tillDate.value = moment().add(1, 'days').format('DD-MM-YYYY');
        currFields.fromTime.value = moment().format('HH:mm');
        currFields.tillTime.value = moment().add(5, 'hours').format('HH:mm');
      }
      currFields.customAttributes.value = discount.customAttributes || [];

      setFormData(currFields);
    }
  }, [discount]);
  const isStrictDDMMYYYY = (s) =>
    /^\d{2}-\d{2}-\d{4}$/.test(String(s || '')) && moment(s, 'DD-MM-YYYY', true)?.isValid();

  const validate = (tabValue) => {
    const updatedFields = {};
    const currTabFormData = Object.fromEntries(
      Object.entries(formData).filter(([key, field]) => field.tab === tabValue),
    );
    const isValid = formDataValidate(currTabFormData, updatedFields);
    setFormData(updatedFields);
    return isValid;
  };

  const handleTabChange = (event, newValue) => {
    if (newValue < tabValue) {
      setTabValue(newValue);
    } else {
      if (validate(tabValue)) {
        setTabValue(newValue);
      }
    }
  };

  const listOfDiscounts = inRoomDiningDiscounts?.map((discounts) => discounts?.name);

  const onNextClick = () => {
    if (validate(tabValue)) {
      setTabValue(tabValue + 1);
    }
  };

  const onCancel = (e) => {
    toggleDrawer('', false, '');
  };

  const onChangeAvailableOn = (e) => {
    if (e.target.value === 'always') {
      formData.fromDate.validations = [];
      formData.fromTime.validations = [];
      formData.tillDate.validations = [];
      formData.tillTime.validations = [];
    } else {
      formData.fromDate.validations = ['required', 'validDate'];
      formData.fromTime.validations = ['required', 'validTime'];
      formData.tillDate.validations = ['required', 'validDate'];
      formData.tillTime.validations = ['required', 'validTime'];
    }
    const availableOnField = { ...formData.availableOn };
    availableOnField.value = e.target.value;
    setFormData({ availableOn: availableOnField });
  };

  const setErrorText = (type) => {
    if (formData[type].errors.required) return formData[type].errors.required;
    if (type === 'fromDate' || type === 'tillDate') {
      if (formData[type].errors.validDate) return formData[type].errors.validDate;
    } else {
      if (formData[type].errors.validTime) return formData[type].errors.validTime;
    }
    return null;
  };

  const isSameDate = moment(formData?.fromDate?.value, 'DD-MM-YYYY').isSame(
    moment(formData?.tillDate?.value, 'DD-MM-YYYY'),
    'day',
  );

  const isFutureDate = moment(formData?.tillDate?.value, 'DD-MM-YYYY').isAfter(
    moment(formData?.fromDate?.value, 'DD-MM-YYYY'),
  );

  useEffect(() => {
    const updatedFormData = formData;

    const startTime = moment(updatedFormData?.fromTime?.value, 'HH:mm');
    const endTime = moment(updatedFormData?.tillTime?.value, 'HH:mm');
    const currentTime = moment();
    const startDate = updatedFormData?.fromDate.value;
    const endDate = updatedFormData?.tillDate.value;
    const currentDate = moment().format('DD-MM-YYYY');
    const isStartDateToday = currentDate === startDate;
    const isEndDateToday = currentDate === endDate;
    const currentStartTime = startTime.isAfter(currentTime);
    const currentEndTime = endTime.isAfter(currentTime);
    const isTimeValid = startTime.isBefore(endTime);

    if (isSameDate && !isFutureDate && isStartDateToday && isEndDateToday) {
      if (!currentStartTime) {
        updatedFormData.fromTime.errors['validTime'] =
          'Selected time must be greater than the current time.';
      } else if (!currentEndTime) {
        updatedFormData.tillTime.errors['validTime'] =
          'Selected time must be greater than the current time.';
      }
    } else if (isSameDate && !(isStartDateToday && isEndDateToday)) {
      updatedFormData.fromTime.errors['validTime'] = '';
      updatedFormData.tillTime.errors['validTime'] = '';
      if (!isTimeValid) {
        updatedFormData.tillTime.errors['validTime'] =
          'Valid Till time should be greater than valid From time';
      }
    } else {
      updatedFormData.fromTime.errors['validTime'] = '';
      updatedFormData.tillTime.errors['validTime'] = '';
    }

    setFormData(updatedFormData);
  }, [formDataChange, isFutureDate, isSameDate]);

  const handleTimePickerChange = (date, value, type) => {
    const currTimeField = { ...formData[type] };
    currTimeField.value = value;
    formDataChange.current = type;
    handleValidation(currTimeField);

    const currentTime = moment();
    const selectedTime = moment(value, 'HH:mm');

    if (selectedTime.isBefore(currentTime) && isSameDate) {
      currTimeField.errors['validTime'] =
        'The selected time should be greater than the current time.';
    }

    setFormData({
      [type]: currTimeField,
    });
  };

  const handleDatePickerChange = (date, value, type) => {
    const curr = { ...formData[type], errors: { ...(formData[type]?.errors || {}) } };
    if (value === '' || value == null) {
      curr.value = '';
      handleValidation(curr);
      setFormData({ [type]: curr });
      return;
    }
    if (typeof value === 'string') {
      curr.value = value;
    }
    if (date && moment(date)?.isValid()) {
      curr.value = moment(date)?.format('DD-MM-YYYY');
    }
    handleValidation(curr);
    const parsed = moment(curr.value, 'DD-MM-YYYY', true);
    if (parsed?.isValid() && parsed?.startOf('day')?.isBefore(moment()?.startOf('day'))) {
      curr.errors = { ...(curr?.errors || {}), validDate: 'Invalid date' };
    } else if (curr?.errors?.validDate) {
      delete curr.errors.validDate;
    }
    if (typeof value === 'string') curr.value = value;
    const raw = curr?.value;
    if (raw) {
      if (!isStrictDDMMYYYY(raw)) {
        curr.errors.validDate = 'Invalid date';
        setFormData({ [type]: curr });
        return;
      }
      const parsed = moment(raw, 'DD-MM-YYYY', true);
      if (parsed?.startOf('day')?.isBefore(moment()?.startOf('day'))) {
        curr.errors.validDate = 'Invalid date';
        setFormData({ [type]: curr });
        return;
      }
      curr.value = parsed?.format('DD-MM-YYYY');
      delete curr?.errors?.validDate;
    }

    setFormData({ [type]: curr });
  };

  const validateSchedule = (tabValue) => {
    if (formData.availableOn.value === 'always') {
      return true;
    } else {
      return validate(tabValue);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (hotelId && validateSchedule(tabValue)) {
      const selectedLanguage = decryptLocalStorage('lang');
      const language = selectedLanguage !== 'en' ? selectedLanguage : '';
      try {
        dispatch(stepUpLoaderCount());
        toggleDrawer('', false, '');
        setLoading(true);
        const payload = {
          code: formData.code.value,
          name: formData.name.value,
          value: formData.value.value,
          upto: formData.upto.value,
          disclaimer: formData.disclaimer.value,
          description: formData.description.value,
          status: formData.status.value,
          customAttributes: formData.customAttributes.value,
          hotelId: hotelId,
          restaurantId,
        };

        if (formData.availableOn.value === 'always') {
          const schedule = {
            always: true,
          };
          payload.schedule = schedule;
        } else {
          const schedule = {
            always: false,
            from: {
              date: formData.fromDate.value,
              time: formData.fromTime.value,
            },
            till: {
              date: formData.tillDate.value,
              time: formData.tillTime.value,
            },
          };
          payload.schedule = schedule;
        }
        if (discount?.id) {
          payload.id = discount.id;
          await editInRoomDiningDiscount(payload, language);
          notificationManager('success', 'Discount updated successfully');
        } else {
          await addInRoomDiningDiscount(payload, language);
          notificationManager('success', 'Discount created successfully');
        }
        dispatch(fetchAllInRoomDining(hotelId, restaurantId));
      } catch (error) {
        if (error?.graphQLErrors) {
          notificationManager('danger', error?.graphQLErrors?.[0]?.message);
        } else {
          discount
            ? notificationManager('danger', 'Failed to update Discount')
            : notificationManager('danger', 'Failed to create Discount');
        }
      } finally {
        dispatch(stepDownLoaderCount());
      }
      setLoading(false);
    }
  };

  useEffect(() => {
    const currTabFormData = Object.fromEntries(
      Object.entries(formData).filter(([key, field]) => field.tab === tabValue),
    );
    const standardValid = formDataValidate(currTabFormData, false);
    const hasManualErrors = Object.values(currTabFormData).some((field) =>
      Object.values(field.errors || {}).some((err) => !!err),
    );
    setIsTabInValid(!standardValid || hasManualErrors);
  }, [formData, tabValue]);

  useEffect(() => {
    const validInterval = moment(`${formData.fromDate.value}`, 'DD-MM-YYYY').isBefore(
      moment(`${formData.tillDate.value}`, 'DD-MM-YYYY'),
    );
    const validTime = moment(`${formData.fromTime.value}`, 'HH:mm').isBefore(
      moment(`${formData.tillTime.value}`, 'HH:mm'),
    );
    if (tabValue === 1 && formData?.fromTime?.errors?.validTime) {
      return setIsTabInValid(true);
    }
    if (
      formData.fromDate.value !== formData.tillDate.value &&
      !validInterval &&
      formData.availableOn.value !== 'always'
    ) {
      setIsValidDateInterval(false);
    } else if (!validTime && formData.availableOn.value !== 'always') {
      setIsValidDateInterval(true);
      setIsValidTimeInterval(false);
    } else {
      setIsValidDateInterval(true);
      setIsValidTimeInterval(true);
    }
  }, [formData]);

  return (
    <form onSubmit={handleSubmit} className='category-create' noValidate>
      <div className='container pt-4 d-flex align-items-end flex-column '>
        <div className='row px-3 w-100 mt-4'>
          <div className='col-md-6'>
            <span className='page-title'>{discount ? 'Edit Discount' : 'Add Discount'}</span>
          </div>
          <div className='col-md-3'>
            <Tabs
              value={tabValue}
              variant='fullWidth'
              indicatorColor='primary'
              onChange={handleTabChange}
              aria-label='roomTypes-add-tabs'
              textColor='primary'
              className='property-tabs'
            >
              <Tab label='Details' />
              <Tab label='Schedule' />
            </Tabs>
          </div>
          <div className='col-md-3 d-flex justify-content-end'>
            <IconButton aria-label='delete' onClick={(e) => onCancel(e)}>
              <CancelIcon />
            </IconButton>
          </div>
        </div>
        <div className='row px-3 w-100 d-flex mt-4 form-scroll'>
          {tabValue === 0 && (
            <div className='row px-3 w-100 d-flex mt-4'>
              <h4 className='tab-title'>Details</h4>
              <div className='row'>
                <div className='col-md-6 mb-3'>
                  <CustomTextField
                    item={formData.name}
                    handleInputChange={(e) => {
                      setFormData({ name: e });
                    }}
                    maxLength={100}
                    endAdornment={true}
                    characterCount={true}
                    multiline={true}
                  />
                </div>
                <div className='col-md-6 mb-3'>
                  <CustomTextField
                    item={formData.code}
                    handleInputChange={(e) => {
                      setFormData({ code: e });
                    }}
                    maxLength={8}
                    endAdornment={true}
                    characterCount={true}
                  />
                </div>
              </div>
              <div className='row'>
                <div className='col-md-6 mb-3'>
                  <CustomTextField
                    item={formData.value}
                    handleInputChange={(e) => {
                      setFormData({ value: e });
                    }}
                    type='number'
                    min={0}
                    max={100}
                  />
                </div>
                <div className='col-md-6 mb-3'>
                  <CustomTextField
                    item={formData.upto}
                    handleInputChange={(e) => {
                      setFormData({ upto: e });
                    }}
                    type='number'
                    min={0}
                    max={99999999}
                  />
                </div>
              </div>
              <div className='row'>
                <div className='col-md-12 mb-3'>
                  <CustomTextField
                    item={formData.disclaimer}
                    handleInputChange={(e) => {
                      setFormData({ disclaimer: e });
                    }}
                    multiline={true}
                  />
                </div>
              </div>
              <div className='row mb-3'>
                <div className='col-md-12 mb-3'>
                  <CustomTextField
                    item={formData.description}
                    handleInputChange={(e) => {
                      setFormData({ description: e });
                    }}
                    multiline={true}
                  />
                </div>
              </div>
              <div className='row px-3 w-100 align-items-center mb-2'>
                <div className='col-auto d-inline-flex align-items-center'>
                  <CustomCheckbox
                    item={formData.status}
                    handleInputChange={(e) => setFormData({ status: e })}
                    color='primary'
                  />
                  <CustomToolTip
                    title='Deactivating this, hides it from Guest app'
                    placement='right-end'
                  >
                    <InfoIcon fontSize='small' className='ms-2 align-middle' />{' '}
                  </CustomToolTip>
                </div>
              </div>
              <KeyValuePairList
                item={formData.customAttributes}
                onListChange={(e) => {
                  setFormData({ customAttributes: e });
                }}
              />
            </div>
          )}
          {tabValue === 1 && (
            <div className='row px-3 w-100 d-flex mt-4'>
              <h5 className='tab-title'>Schedule</h5>
              <div className='custom-upload col-md-12'>
                <RadioGroup
                  row
                  aria-label={formData.availableOn.fieldName}
                  onChange={(e) => {
                    onChangeAvailableOn(e);
                  }}
                  value={formData.availableOn.value}
                  name={formData.availableOn.fieldName}
                  className='document-type mb-3'
                >
                  <FormControlLabel
                    value='always'
                    control={<Radio color='primary' />}
                    label='Always Active'
                    className='me-5'
                  />
                  <FormControlLabel
                    value='custom'
                    control={<Radio color='primary' />}
                    label='Custom'
                  />
                </RadioGroup>
              </div>
              {formData.availableOn.value === 'custom' && (
                <>
                  <div className='row'>
                    <h4 className='tab-title'>Valid From</h4>
                    <div className='col-md-6 mb-2'>
                      <MuiPickersUtilsProvider utils={MomentUtils}>
                        <KeyboardDatePicker
                          variant='inline'
                          minDate={new Date()}
                          margin='normal'
                          id='fromDate'
                          label='Date'
                          className='col-md-12 mb-2'
                          format='DD-MM-YYYY'
                          required={formData.fromDate.validations.includes('required')}
                          inputValue={formData.fromDate.value}
                          onChange={(date, value) =>
                            handleDatePickerChange(date, value, 'fromDate')
                          }
                          error={
                            formData.fromDate?.errors.required ||
                            formData.fromDate?.errors.validDate
                              ? true
                              : false
                          }
                          disableMaskedInput
                          helperText={setErrorText('fromDate')}
                        />
                      </MuiPickersUtilsProvider>
                    </div>
                    <div className='col-md-6'>
                      <MuiPickersUtilsProvider utils={MomentUtils}>
                        <KeyboardTimePicker
                          variant='inline'
                          margin='normal'
                          id='fromTime'
                          label='Time'
                          className='col-md-12 mb-2'
                          ampm={false}
                          format='HH:mm'
                          required={formData.fromTime.validations.includes('required')}
                          inputValue={formData.fromTime.value}
                          onChange={(date, value) =>
                            handleTimePickerChange(date, value, 'fromTime')
                          }
                          error={
                            formData.fromTime?.errors.required ||
                            formData.fromTime?.errors.validTime
                              ? true
                              : false
                          }
                          helperText={setErrorText('fromTime')}
                          keyboardIcon={<WatchLaterIcon />}
                        />
                      </MuiPickersUtilsProvider>
                    </div>
                  </div>
                  <div className='row'>
                    <h5 className='tab-title'>Valid Till</h5>
                    <div className='col-md-6 mb-2'>
                      <MuiPickersUtilsProvider utils={MomentUtils}>
                        <KeyboardDatePicker
                          variant='inline'
                          minDate={new Date()}
                          margin='normal'
                          id='tillDate'
                          label='Date'
                          className='col-md-12 mb-2'
                          format='DD-MM-YYYY'
                          required={formData.tillDate.validations.includes('required')}
                          inputValue={formData.tillDate.value}
                          onChange={(date, value) =>
                            handleDatePickerChange(date, value, 'tillDate')
                          }
                          error={
                            formData.tillDate?.errors.required ||
                            formData.tillDate?.errors.validDate
                              ? true
                              : false
                          }
                          helperText={setErrorText('tillDate')}
                          disableMaskedInput
                        />
                      </MuiPickersUtilsProvider>
                      {!isValidDateInterval && (
                        <p className='field-error mt-1'>
                          'Valid from' date should take place before the 'Valid till' date
                        </p>
                      )}
                    </div>
                    <div className='col-md-6'>
                      <MuiPickersUtilsProvider utils={MomentUtils}>
                        <KeyboardTimePicker
                          variant='inline'
                          margin='normal'
                          id='tillTime'
                          label='Time'
                          className='col-md-12'
                          ampm={false}
                          format='HH:mm'
                          required={formData.tillTime.validations.includes('required')}
                          inputValue={formData.tillTime.value}
                          onChange={(date, value) =>
                            handleTimePickerChange(date, value, 'tillTime')
                          }
                          error={
                            formData.tillTime?.errors.required ||
                            formData.tillTime?.errors.validTime
                              ? true
                              : false
                          }
                          helperText={setErrorText('tillTime')}
                          keyboardIcon={<WatchLaterIcon />}
                        />
                      </MuiPickersUtilsProvider>
                      {!isFutureDate && !isValidTimeInterval && (
                        <p className='field-error mt-1'>
                          `'Valid from' time should take place before the 'Valid till' time`
                        </p>
                      )}
                    </div>
                  </div>
                </>
              )}
            </div>
          )}
        </div>
        <div className='row mx-2 mt-auto px-4 w-100 pb-5'>
          <div className='col-md-12 d-flex justify-content-start'>
            {tabValue < 1 ? (
              <Button
                variant='contained'
                color='primary'
                onClick={onNextClick}
                size='large'
                className='me-3'
                disabled={isTabInValid}
              >
                Next
              </Button>
            ) : (
              <Button
                disabled={
                  loading ||
                  isTabInValid ||
                  !isValidDateInterval ||
                  (!isFutureDate && !isValidTimeInterval)
                }
                onClick={handleSubmit}
                variant='contained'
                color='primary'
                className='me-3'
                size='large'
              >
                {discount ? 'Update' : 'Add'}
              </Button>
            )}
            <Button
              disabled={loading}
              variant='outlined'
              type='button'
              color='secondary'
              size='large'
              onClick={(e) => onCancel(e)}
            >
              Cancel
            </Button>
          </div>
          {loading && <div className='pt-4 col-md-12'>{<LinearProgressBar />}</div>}
        </div>
      </div>
    </form>
  );
};

export default DiscountCreate;
